import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_user_exports_grid___ds_user_exports_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { hide_downloaded?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, description?: string, created_on?: string, completed_on?: string, source?: string, job_id?: string, progress?: number, attachment_id?: string, downloaded_on?: string, error?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { hide_downloaded?: boolean, $keys: string[] }): Promise<{ result?: { id?: string, description?: string, created_on?: string, completed_on?: string, source?: string, job_id?: string, progress?: number, attachment_id?: string, downloaded_on?: string, error?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      hide_downloaded?: boolean    }) {
      return false;
    }
}
